module.exports = {
	"genre": {
		"genre-id-1": "Różnorodny",
		"genre-id-2": "Blues/Country/Folk",
		"genre-id-3": "Blues",
		"genre-id-4": "Kraj",
		"genre-id-5": "Ludowy",
		"genre-id-6": "Francuska piosenka",
		"genre-id-7": "Francuscy wykonawcy piosenek",
		"genre-id-8": "Retro francuska piosenka",
		"genre-id-9": "Francuski rock",
		"genre-id-10": "Klasyczny",
		"genre-id-11": "Elektroniczny czy betonowy",
		"genre-id-12": "muzyka konkretna",
		"genre-id-13": "Muzyka elektroniczna",
		"genre-id-14": "Muzyka minimalistyczna",
		"genre-id-15": "Melodie i pieśni",
		"genre-id-16": "Lieder (Niemcy)",
		"genre-id-17": "Piosenki",
		"genre-id-18": "Melodie",
		"genre-id-19": "Melodie (Anglia)",
		"genre-id-20": "Melodie (Europa Północna)",
		"genre-id-21": "Melodie (Francja)",
		"genre-id-22": "Muzyka koncertowa",
		"genre-id-23": "Inne instrumenty",
		"genre-id-24": "Koncerty klawiszowe",
		"genre-id-25": "Koncerty skrzypcowe",
		"genre-id-26": "Koncerty wiolonczelowe",
		"genre-id-27": "Muzyka kameralna",
		"genre-id-28": "Inne kursy szkoleniowe",
		"genre-id-29": "Inne instrumenty solowe",
		"genre-id-30": "Fortepian solo",
		"genre-id-31": "Kwartety",
		"genre-id-32": "Kwintety",
		"genre-id-33": "Duety",
		"genre-id-34": "Tria",
		"genre-id-35": "skrzypce solo",
		"genre-id-36": "Solo na wiolonczelę",
		"genre-id-37": "Muzyka symfoniczna",
		"genre-id-38": "Balety",
		"genre-id-39": "Muzyka sceniczna",
		"genre-id-40": "Muzyka do kina",
		"genre-id-41": "Otwarcia",
		"genre-id-42": "Poematy symfoniczne",
		"genre-id-43": "Symfonie",
		"genre-id-44": "Muzyka wokalna (świecka i sakralna)",
		"genre-id-45": "Kantaty (świeckie)",
		"genre-id-46": "Muzyka chóralna (na chór)",
		"genre-id-47": "Muzyka dla zespołów wokalnych",
		"genre-id-48": "Oratoria świeckie",
		"genre-id-49": "Recitale wokalne",
		"genre-id-50": "Muzyka wokalna sakralna",
		"genre-id-51": "Kantaty święte",
		"genre-id-52": "Chóry święte",
		"genre-id-53": "Msze, Pasje, Requiem",
		"genre-id-54": "Oratoria Święte",
		"genre-id-55": "Opera",
		"genre-id-56": "Fragmenty opery",
		"genre-id-57": "Kompletne opery",
		"genre-id-58": "Operetka",
		"genre-id-59": "Dykcja",
		"genre-id-60": "Pedagogia",
		"genre-id-61": "Dokumenty historyczne",
		"genre-id-62": "Humor",
		"genre-id-63": "Literatura",
		"genre-id-64": "Elektroniczny",
		"genre-id-65": "Otoczenia",
		"genre-id-66": "Downtempo",
		"genre-id-67": "Drum &amp; Bass",
		"genre-id-68": "Dom",
		"genre-id-69": "Salonik",
		"genre-id-70": "Techno",
		"genre-id-71": "Trans",
		"genre-id-72": "Trip Hop",
		"genre-id-73": "Atmosfera dziecięca",
		"genre-id-74": "Akordeon",
		"genre-id-75": "Bajki i rymowanki",
		"genre-id-76": "Edukacyjny",
		"genre-id-77": "Karaoke",
		"genre-id-78": "Muzyka wojskowa",
		"genre-id-79": "Relaks",
		"genre-id-80": "Jazz",
		"genre-id-81": "Bądź Bopem",
		"genre-id-82": "Fajny jazz",
		"genre-id-83": "Free jazz i awangarda",
		"genre-id-84": "Ewangelia",
		"genre-id-85": "Współczesny jazz",
		"genre-id-86": "Jazz fusion i jazz rock",
		"genre-id-87": "Cygański jazz",
		"genre-id-88": "Tradycyjny jazz i Nowy Orlean",
		"genre-id-89": "Jazz wokalny",
		"genre-id-90": "Jazz latynoski",
		"genre-id-91": "Oryginalne ścieżki dźwiękowe",
		"genre-id-92": "Oryginalne ścieżki dźwiękowe do filmów",
		"genre-id-93": "Musicale",
		"genre-id-94": "Muzyka świata",
		"genre-id-95": "Afryka",
		"genre-id-96": "Afrobeat",
		"genre-id-97": "Azja",
		"genre-id-98": "Brazylia",
		"genre-id-99": "Celtycki",
		"genre-id-100": "Europa Wschodnia",
		"genre-id-101": "Fado",
		"genre-id-102": "Flamenco",
		"genre-id-103": "Muzyka etniczna",
		"genre-id-104": "Muzyka indyjska",
		"genre-id-105": "Wschód",
		"genre-id-106": "Rai",
		"genre-id-107": "Salsa",
		"genre-id-108": "Tango",
		"genre-id-109": "Muzyka świata",
		"genre-id-110": "Jidysz i klezmer",
		"genre-id-111": "Zouk i Antyle",
		"genre-id-112": "Pop/Rock",
		"genre-id-113": "Alternatywa i indie",
		"genre-id-114": "Piosenkarze",
		"genre-id-115": "Hard Rock",
		"genre-id-116": "Metal",
		"genre-id-117": "Muzyka pop",
		"genre-id-118": "Punk - Nowa Fala",
		"genre-id-119": "Głaz",
		"genre-id-120": "Rock progresywny",
		"genre-id-121": "Rockabilly",
		"genre-id-122": "Międzynarodowa różnorodność",
		"genre-id-123": "Reggae",
		"genre-id-124": "Dancehall",
		"genre-id-125": "Zdubbingować",
		"genre-id-126": "Ska i Rocksteady",
		"genre-id-127": "Soul/Funk/R&B",
		"genre-id-128": "Kwasowy jazz",
		"genre-id-129": "Taniec",
		"genre-id-130": "Dyskoteka",
		"genre-id-131": "Boj",
		"genre-id-132": "R&B",
		"genre-id-133": "Hip-Hop/Rap",
		"genre-id-134": "Pijany",
		"genre-id-135": "Operetka",
		"genre-id-137": "Koncerty trąbkowe",
		"genre-id-138": "Koncerty na instrumenty dęte",
		"genre-id-139": "Zwrotnica",
		"genre-id-140": "Dokumenty",
		"genre-id-141": "Nowa Era",
		"genre-id-142": "Atmosfera",
		"genre-id-144": "Zwrotnica",
		"genre-id-145": "Dixieland",
		"genre-id-146": "Ragtime",
		"genre-id-147": "Serial telewizyjny",
		"genre-id-148": "Gry wideo",
		"genre-id-149": "Latynos",
		"genre-id-150": "Ameryka Północna",
		"genre-id-151": "Europa",
		"genre-id-152": "cygański",
		"genre-id-153": "Muzyka tradycyjna",
		"genre-id-154": "Maghreb",
		"genre-id-155": "Rosja",
		"genre-id-156": "Turcja",
		"genre-id-157": "Indie pop",
		"genre-id-158": "Sprośne piosenki",
		"genre-id-159": "Muzyka świąteczna",
		"genre-id-160": "Niemiecka piosenka",
		"genre-id-161": "Szkocja",
		"genre-id-162": "Hiszpania",
		"genre-id-163": "Grecja",
		"genre-id-164": "Irlandia",
		"genre-id-165": "Włoska piosenka",
		"genre-id-166": "Portugalia",
		"genre-id-167": "Dzieci",
		"genre-id-176": "Świecka muzyka wokalna",
		"genre-id-173": "Szlager",
		"genre-id-171": "Muzyka stimmungs",
		"genre-id-172": "Muzyka ludowa",
		"genre-id-174": "irlandzki celtycki",
		"genre-id-175": "Irlandzka muzyka pop",
		"genre-id-168": "Szwajcarska muzyka ludowa",
		"genre-id-178": "niemiecki",
		"genre-id-177": "angielski",
		"genre-id-170": "francuski",
		"genre-id-179": "Holenderski",
		"genre-id-180": "Bolero",
		"genre-id-181": "Miejski Latynos",
		"genre-id-182": "Reggaeton",
		"genre-id-183": "MPB",
		"genre-id-184": "Bossa Nova",
		"genre-id-185": "Samba",
		"genre-id-186": "Forro",
		"genre-id-187": "Pagoda",
		"genre-id-188": "Funk Brasil",
		"genre-id-189": "Sertanejo",
		"genre-id-190": "Japonia",
		"genre-id-191": "J-Pop",
		"genre-id-192": "Tradycyjna muzyka japońska",
		"genre-id-193": "Korea",
		"genre-id-194": "K-Pop",
		"genre-id-195": "Tradycyjna muzyka koreańska",
		"genre-id-196": "Anime/Gry wideo",
		"genre-id-197": "Anime"
	},
	"article-cat": {
		"article-cat-2": "-- ARCHIWUM OGÓLNE --",
		"article-cat-4": "Spotkania",
		"article-cat-5": "-- ARCHIWUM GER / CZYTAJ / KLASYKA --",
		"article-cat-7": "Na scenie",
		"article-cat-8": "Nominacje i nagrody",
		"article-cat-10": "W mediach",
		"article-cat-22": "Drogi zmarły",
		"article-cat-51": "Dyskografia",
		"article-cat-53": "Bibliografia",
		"article-cat-54": "Portrety",
		"article-cat-97": "Aktualności",
		"article-cat-98": "Główne sekcje",
		"article-cat-100": "Branże",
		"article-cat-101": "Nowości",
		"article-cat-117": "Wiadomości Jazzowe",
		"article-cat-122": "Aktualności",
		"article-cat-189": "Wywiad",
		"article-cat-197": "Słuchanie porównawcze",
		"article-cat-199": "Spotkania",
		"article-cat-209": "Moja pamięć śpiewa",
		"article-cat-226": "Jaskinia Canem",
		"article-cat-227": "Fortissimo",
		"article-cat-229": "Czy możesz?",
		"article-cat-238": "Recenzje magazynów",
		"article-cat-252": "Callassoterapia",
		"article-cat-260": "Symphoman",
		"article-cat-267": "Krzyże",
		"article-cat-279": "Koncerty",
		"article-cat-286": "Poufny",
		"article-cat-287": "Dziennik",
		"article-cat-293": "Wydarzenia",
		"article-cat-295": "Koncerty i wycieczki",
		"article-cat-297": "Hi-Fi",
		"article-cat-298": "Stanowiska testowe",
		"article-cat-299": "Praktyczny",
		"article-cat-301": "Aktualności",
		"article-cat-302": "Wyjątkowe nagrania dźwiękowe",
		"article-cat-303": "Magowie dźwięku",
		"article-cat-304": "Trax",
		"article-cat-305": "Stara woskowina w czystych uszach",
		"article-cat-306": "Voxpop",
		"article-cat-311": "Berlińska Orkiestra Filharmoniczna",
		"article-cat-312": "André Tubeuf: Pamięć i krajobrazy",
		"article-cat-315": "François Hudry: Cum grano salis",
		"article-cat-316": "Klasyczny Qibuz",
		"article-cat-318": "Artykuły redakcyjne",
		"article-cat-319": "Qobuz w",
		"article-cat-320": "Marsylia",
		"article-cat-321": "Festiwal Barokowy w Paryżu",
		"article-cat-322": "Maniacy Hi-Fi",
		"article-cat-323": "Rennes",
		"article-cat-324": "Artykuły redakcyjne",
		"article-cat-325": "Kibuz",
		"article-cat-326": "Artykuł wstępny Jeana-Michela Prousta",
		"article-cat-327": "Jean-Michel Proust: wiadomość miesiąca",
		"article-cat-328": "Poniedziałek Qibuz",
		"article-cat-329": "Lille",
		"article-cat-330": "Tak, Mistrzowie!",
		"article-cat-331": "Minuta Qobuz",
		"article-cat-332": "Nowoczesny",
		"article-cat-333": "Biuletyny",
		"article-cat-334": "Tygodniowy biuletyn Qobuz",
		"article-cat-335": "Biuletyn promocyjny",
		"article-cat-336": "Biuletyn Qobuz Hi-Fi",
		"article-cat-337": "Klasyczny biuletyn",
		"article-cat-339": "Biuletyn elektroniczny",
		"article-cat-340": "Biuletyn dla dzieci",
		"article-cat-341": "Biuletyn Dykcyjny",
		"article-cat-342": "Smartfony zgodne z dźwiękiem HD",
		"article-cat-343": "Biuletyn Piosenki Francuskiej",
		"article-cat-344": "France Musique",
		"article-cat-345": "Nowoczesny styl",
		"article-cat-347": "Biuletyn Ambiance",
		"article-cat-350": "Po angielsku",
		"article-cat-351": "Po niemiecku",
		"article-cat-352": "Po holendersku",
		"article-cat-353": "Po angielsku",
		"article-cat-354": "Po niemiecku",
		"article-cat-355": "Po holendersku",
		"article-cat-356": "Po holendersku",
		"article-cat-357": "Po niemiecku",
		"article-cat-358": "Po angielsku",
		"article-cat-359": "Stare cekiny i stare napierśniki",
		"article-cat-360": "Hannah Krooz",
		"article-cat-361": "Samouczki",
		"article-cat-362": "Nowości Klasyka",
		"article-cat-363": "Studio Qobuz",
		"article-cat-364": "Studio Qobuz",
		"article-cat-365": "W centrum uwagi",
		"article-cat-368": "Archiwa",
		"article-cat-369": "Szef kuchni Qobuz",
		"article-cat-370": "Jedna okładka / jedno słowo"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/apiLocale/apiPl.json
// module id = 563
// module chunks = 0